import ReactGA from 'react-ga'

export const trackPage = (pathname) => {
  ReactGA.set({ page: pathname });
  ReactGA.pageview(pathname);
}

export const trackEvent = (category, action, label = false, value = false) => {
  let event = {};
  event['category'] = category;
  event['action'] = action;
  if(label) {
    event['label'] = label;
  }
  if(value) {
    event['value'] = value;
  }
  ReactGA.event(event);
}



// WEBPACK FOOTER //
// ./src/app/utilities/analytics.jsx